// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._y-0 {\n  line-height: 1.4;\n}\n\n._y-1 {\n  font-weight: 600;\n}\n\n._y-2 {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n._y-3 {\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: underline;\n  color: var(--redo-colors-blue-500);\n}\n\n._y-4 {\n  font-weight: 600;\n}\n", ""]);
// Exports
export var text = "_y-0";
export var estimate = "_y-1";
export var truckIcon = "_y-2";
export var zipCode = "_y-3";
export var title = "_y-4";
export default ___CSS_LOADER_EXPORT___;
